<template id="Book">
	<div @click="close_book()" class="bookmain fade-in">
		<span @click="close_book()" class="bookclosebtn material-icons md-36 md-dark">close</span>
		<div class="bookcontainer">
			<iframe frameborder="0" style="height:100%;width:100%;border:none;" src='https://forms.zohopublic.eu/distributionautomobilesdisco/form/Bookingstage/formperma/EM5uZrdECpoAI-OUwsAEx9aGmloWUwMf_Zz7uWgwxi0'></iframe>
		</div>
	</div>
	
</template>

<script>
export default {
	name: 'Book',
		data () {
		return {
		}
	},
	methods:{
		close_book(){
			this.$router.push('/conduite/stages')
		}
	}
}
</script>

<style scoped>
.bookmain{
	background-color: rgba(20,20,20, 0.9);
	position:fixed;
	top:0;
	left:0;
	height:100%;
	width:100%;
	overflow-y: scroll;
	z-index:100;
}
.bookcontainer{
	padding:30px;
	width:50%;
	height:90%;
	margin:0 auto;
}
/* Close button */
.bookclosebtn {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  color: white;
}
.bookclosebtn:hover {
  color: #ccc;
}

@media all and (max-width: 800px) {
	.bookcontainer{
		width:90%;
		height:90%;
		padding:20px;
	}
  }

</style>


// WEBPACK FOOTER //
// src/components/Conduite/Book.vue